import React, { ReactNode } from 'react';
import { useNewsBriefing } from '../_context/NewsContext';
interface LayoutProps {
  children: ReactNode;
}

export const LayoutNewsBriefingSwiper: React.FC<LayoutProps> = ({ children }) => {
  const { isLoading } = useNewsBriefing();

  return (
    <section
      className={`flex h-[100svh] w-full flex-col items-center justify-center gap-[24px] bg-gr-50 px-[20px] py-[28px] 
        ${isLoading && 'pb-[10px] pt-[13px]'}
      `}
    >
      {children}
    </section>
  );
};

export const LayoutSwiperTop: React.FC<LayoutProps> = ({ children }) => {
  return <div className="flex h-full w-full flex-1 flex-col gap-[16px]">{children}</div>;
};

export const LayoutTopContent: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="group flex h-full min-h-[300px] w-full flex-1  flex-col  ">{children}</div>
  );
};

export const LayoutBottomContent: React.FC<LayoutProps> = ({ children }) => {
  return <div className="flex min-h-[6px] w-full items-center justify-center">{children}</div>;
};
